import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./CartPage.css";
import Cart from "../components/Cart";
import { useSelector } from "react-redux";

function CartPage() {
  const shoppingCart = useSelector((state) => state.cart);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container cart-page mb-5 animate__animated animate__fadeIn">
      <div className="text-center">
        <h1>Your cart</h1>
        {shoppingCart.length !== 0 && (
          <Link to="/" className="link-yellow">
            Continue shopping
          </Link>
        )}
      </div>
      <Cart />
    </div>
  );
}

export default CartPage;
